const API_VER = 'v1.0'
export const BaseEndpoints = {
    BEAT_URI: `/beat/api/${API_VER}/periodictasks/`,
}
